var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "92px",
    height: "92px",
    viewBox: "0 0 92 92",
    enableBackground: "new 0 0 92 92",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46,0C20.6,0,0,20.6,0,46s20.6,46,46,46s46-20.6,46-46S71.4,0,46,0z M46,84C25,84,8,67,8,46S25,8,46,8s38,17,38,38 S67,84,46,84z M61.3,55.6c1.6,1.6,1.6,4.1,0,5.7c-0.8,0.8-1.8,1.2-2.8,1.2s-2-0.4-2.8-1.2L43.2,48.8C42.4,48.1,42,47.1,42,46V22.2 c0-2.2,1.8-4,4-4s4,1.8,4,4v22.2L61.3,55.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.b21231c1333f409473528c7f9751e560.svg";
export { ForwardRef as ReactComponent };